import parse from 'html-react-parser';
import DOMPurify from 'isomorphic-dompurify';

const parseHtml = (html) => {
    const cleanHTML = DOMPurify.sanitize(html, {
        ADD_ATTR: ['target'],
        USE_PROFILES: { html: true },
    });

    return parse(cleanHTML);
};

export default parseHtml;
